<template>
  <va-card class="container" style="overflow-x: auto; overflow-y: visible;">
    <div class="body">
      <div>
        <label class="form-label">Email</label>
        <va-input class="email-input" v-model="email" placeholder="Enter email address here" />
        <label v-if="emailError === true" class="error-label">Please enter email</label>
      </div>
      <div class="form-container select-container">
        <label class="form-label">Select one or more schools for user</label>
        <va-select multiple label="School Names" v-model="entities" :options="options"
          :text-by="(options) => options.name">
        </va-select>
        <label v-if="selectionError === true" class="error-label">Please select at least one school</label>
      </div>
      <div class="flex xs12 form-container button-container">
        <div class="alignleft">
          <va-button class="btn" color="gray" @click="cancel">Cancel</va-button>
        </div>
        <div class="alignright">
          <va-button class="btn" color="gray" @click="save">Invite</va-button>
        </div>
      </div>
      <div class="flex xs12 form-container error-container">
        <label v-if="apiError !== ''" class="error-label alignright">{{ apiError }}</label>
      </div>
    </div>
  </va-card>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "invite-user-modal",
  components: {
  },
  props: {
    title: {
      type: String,
      required: false,
      note: "Title for the multiple selection"
    },
    options: {
      type: Array,
      required: false,
      default: () => [],
      note: "Options of dropdown. An array of options with id and name"
    },
    selectedEntity: {
      type: Number,
      required: false,
      note: "Current selected entity"
    }
  },
  data() {
    return {
      email: "",
      entities: [],
      emailError: false,
      selectionError: false,
      apiError: ""
    };
  },
  created() {
    if (!this.entities.some(e => e.id === this.selectedEntity)) {
      this.entities.push(this.options.find(option => option.id === this.selectedEntity));
    }
  },
  computed: {
  },

  methods: {
    ...mapActions({
      inviteNewUser: "admin/inviteNewUser"
    }),

    cancel() {
      this.$emit("close");
    },
    save() {
      this.emailError = false;
      this.selectionError = false;
      this.apiError = "";

      if (this.email === "") {
        this.emailError = true;
      }
      if (this.entities.length === 0) {
        this.selectionError = true;
      }
      if (this.emailError === false && this.selectionError === false) {
        this.inviteNewUser({ email: this.email, entities: this.entities.map(e => e.id), selectedEntity: this.selectedEntity })
          .then(res => {
            if (res.success == true) {
              this.$vaToast.init({
                message: 'User created successfully',
                iconClass: 'fa-check',
                position: 'bottom-right',
                duration: 1500
              })
              this.$emit("close");
            }
            else {
              this.apiError = res.errorMessage;
            }
          })
          .catch(err => {
            this.apiError = "Error sending invite request";
          })
          .finally(() => {
            //stop loading animation
          });
      }
    }
  }
};
</script>

<style scoped>
.container {
  box-shadow: none !important;
  background: white !important;
  color: black !important;
}

.body {
  margin-top: 1rem;
}

.alignright {
  float: right;
}

.alignleft {
  float: left;
}

.multiselect {
  --ms-placeholder-color: #9CA3AF;
  --ms-max-height: 10rem;
  --ms-bg: #2E3349;
  --ms-dropdown-bg: #3f566d;
  --ms-dropdown-border-color: #39404b;
  --ms-dropdown-border-width: 1px;
  --ms-dropdown-radius: 4px;
  color: #fff;
}

.multiselect-options {
  background: #ccc;
  color: #252A30 !important
}

.selection {
  margin-top: 0.25rem;
}

.form-label {
  font-size: 1rem;
  color: #34495e;
  width: 100%;
}

.email-input {
  width: 100%;
  border-color: rgba(60, 60, 60, 0.26);
  border-width: thin;
  border-radius: 4px;
  height: 2rem;
}

.error-label {
  font-size: 0.75rem;
  color: #d43d27;
  font-weight: bold;
  margin-left: 0.25rem;
}

.form-container {
  margin-top: 0.75rem;
}

.select-container {
  height: 4rem;
}

.button-container {
  height: 3rem;
}

.error-container {
  height: 1rem;
}
</style>